import { SVGProps } from 'react'

const SvgEmptyTable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="201"
    height="119"
    viewBox="0 0 201 119"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3543_5528)">
      <path d="M201 111.857H0V111.943H201V111.857Z" fill="#F7F7F7" />
      <path d="M180.86 117.35H167.545V117.435H180.86V117.35Z" fill="#F7F7F7" />
      <path
        d="M133.15 118.279H129.657V118.364H133.15V118.279Z"
        fill="#F7F7F7"
      />
      <path
        d="M167.144 114.182H159.429V114.268H167.144V114.182Z"
        fill="#F7F7F7"
      />
      <path
        d="M38.4511 114.755H21.0887V114.841H38.4511V114.755Z"
        fill="#F7F7F7"
      />
      <path
        d="M44.5776 114.755H42.033V114.841H44.5776V114.755Z"
        fill="#F7F7F7"
      />
      <path
        d="M90.5102 116.196H52.8508V116.281H90.5102V116.196Z"
        fill="#F7F7F7"
      />
      <path
        d="M95.2781 96.6333H17.6519C16.3856 96.6333 15.3564 95.7594 15.3564 94.6842V2.03187C15.3564 0.956617 16.3856 0.0827637 17.6519 0.0827637H95.2781C96.5444 0.0827637 97.5735 0.956617 97.5735 2.03187V94.6842C97.5735 95.7594 96.5444 96.6333 95.2781 96.6333ZM17.6519 0.168101C16.4418 0.168101 15.4569 1.00441 15.4569 2.03187V94.6842C15.4569 95.7117 16.4418 96.548 17.6519 96.548H95.2781C96.4881 96.548 97.473 95.7117 97.473 94.6842V2.03187C97.473 1.00441 96.4881 0.168101 95.2781 0.168101H17.6519Z"
        fill="#F7F7F7"
      />
      <path
        d="M182.231 96.6333H104.604C103.338 96.6333 102.309 95.7594 102.309 94.6842V2.03187C102.309 0.956617 103.338 0.0827637 104.604 0.0827637H182.231C183.497 0.0827637 184.526 0.956617 184.526 2.03187V94.6842C184.526 95.7594 183.497 96.6333 182.231 96.6333ZM104.604 0.168101C103.394 0.168101 102.41 1.00441 102.41 2.03187V94.6842C102.41 95.7117 103.394 96.548 104.604 96.548H182.231C183.441 96.548 184.426 95.7117 184.426 94.6842V2.03187C184.426 1.00441 183.441 0.168101 182.231 0.168101H104.604Z"
        fill="#F7F7F7"
      />
      <path
        d="M100.5 118.62C143.547 118.62 178.444 116.561 178.444 114.022C178.444 111.483 143.547 109.425 100.5 109.425C57.4528 109.425 22.5562 111.483 22.5562 114.022C22.5562 116.561 57.4528 118.62 100.5 118.62Z"
        fill="#E6F2FE"
      />
      <path
        d="M167.397 11.2544H33.603C30.3149 11.2544 27.6494 13.9473 27.6494 17.2692V103.689C27.6494 107.011 30.3149 109.704 33.603 109.704H167.397C170.685 109.704 173.35 107.011 173.35 103.689V17.2692C173.35 13.9473 170.685 11.2544 167.397 11.2544Z"
        fill="white"
      />
      <path
        d="M167.397 109.923H33.603C30.202 109.923 27.4323 107.125 27.4323 103.689V17.2692C27.4323 13.8334 30.202 11.0352 33.603 11.0352H167.401C170.802 11.0352 173.571 13.8334 173.571 17.2692V103.689C173.571 107.125 170.802 109.923 167.401 109.923H167.397ZM33.603 11.4738C30.4392 11.4738 27.8664 14.073 27.8664 17.2692V103.689C27.8664 106.886 30.4392 109.485 33.603 109.485H167.401C170.564 109.485 173.137 106.886 173.137 103.689V17.2692C173.137 14.073 170.564 11.4738 167.401 11.4738H33.603Z"
        fill="#66B0F6"
      />
      <path
        d="M39.1626 17.5903C39.1626 18.6625 38.3023 19.5275 37.2451 19.5275C36.1878 19.5275 35.3275 18.6584 35.3275 17.5903C35.3275 16.5222 36.1878 15.6531 37.2451 15.6531C38.3023 15.6531 39.1626 16.5222 39.1626 17.5903Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M51.7615 18.7235H42.3467C41.7276 18.7235 41.2251 18.2118 41.2251 17.5904C41.2251 16.9649 41.7316 16.4573 42.3467 16.4573H51.7615C52.3806 16.4573 52.8831 16.969 52.8831 17.5904C52.8831 18.2158 52.3766 18.7235 51.7615 18.7235Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M97.1472 18.2117H90.5423C90.2006 18.2117 89.9272 17.9315 89.9272 17.5904C89.9272 17.2452 90.2046 16.969 90.5423 16.969H97.1472C97.4889 16.969 97.7622 17.2492 97.7622 17.5904C97.7622 17.9356 97.4848 18.2117 97.1472 18.2117Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M111.969 18.2117H105.364C105.023 18.2117 104.749 17.9315 104.749 17.5904C104.749 17.2452 105.027 16.969 105.364 16.969H111.969C112.311 16.969 112.584 17.2492 112.584 17.5904C112.584 17.9356 112.307 18.2117 111.969 18.2117Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M126.791 18.2117H120.186C119.844 18.2117 119.571 17.9315 119.571 17.5904C119.571 17.2452 119.848 16.969 120.186 16.969H126.791C127.132 16.969 127.406 17.2492 127.406 17.5904C127.406 17.9356 127.128 18.2117 126.791 18.2117Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M141.616 18.2117H135.012C134.67 18.2117 134.396 17.9315 134.396 17.5904C134.396 17.2452 134.674 16.969 135.012 16.969H141.616C141.958 16.969 142.231 17.2492 142.231 17.5904C142.231 17.9356 141.954 18.2117 141.616 18.2117Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.7"
        d="M160.583 18.687H150.589C149.99 18.687 149.504 18.1956 149.504 17.5904C149.504 16.9853 149.99 16.4939 150.589 16.4939H160.583C161.182 16.4939 161.668 16.9853 161.668 17.5904C161.668 18.1956 161.182 18.687 160.583 18.687Z"
        fill="#C8C8C8"
      />
      <path
        d="M155.856 31.0636L46.262 31.0043C41.8963 31.0019 38.3262 31.2309 38.2881 31.5156L37.0692 40.6093C37.031 40.894 40.5392 41.1268 44.9049 41.1292L154.499 41.1885C158.864 41.1908 162.434 40.9619 162.473 40.6771L163.692 31.5835C163.73 31.2987 160.222 31.0659 155.856 31.0636Z"
        fill="#F7F7F7"
      />
      <path
        d="M155.856 42.7652L46.262 42.7059C41.8963 42.7036 38.3262 42.9325 38.2881 43.2173L37.0692 52.3109C37.031 52.5957 40.5392 52.8285 44.9049 52.8308L154.499 52.8901C158.864 52.8925 162.434 52.6636 162.473 52.3788L163.692 43.2852C163.73 43.0004 160.222 42.7676 155.856 42.7652Z"
        fill="#F7F7F7"
      />
      <path
        d="M155.856 54.4674L46.262 54.4081C41.8963 54.4057 38.3262 54.6347 38.2881 54.9194L37.0692 64.0131C37.031 64.2979 40.5392 64.5306 44.9049 64.533L154.499 64.5923C158.864 64.5946 162.434 64.3657 162.473 64.0809L163.692 54.9873C163.73 54.7025 160.222 54.4698 155.856 54.4674Z"
        fill="#F7F7F7"
      />
      <path
        d="M155.856 66.169L46.2619 66.1097C41.8962 66.1074 38.3261 66.3363 38.2879 66.6211L37.0691 75.7147C37.0309 75.9995 40.5391 76.2323 44.9048 76.2346L154.499 76.2939C158.864 76.2963 162.434 76.0674 162.473 75.7826L163.691 66.689C163.73 66.4042 160.221 66.1714 155.856 66.169Z"
        fill="#F7F7F7"
      />
      <path
        d="M155.856 77.871L46.2619 77.8117C41.8962 77.8093 38.3261 78.0382 38.2879 78.323L37.0691 87.4166C37.0309 87.7014 40.5391 87.9342 44.9048 87.9365L154.499 87.9959C158.864 87.9982 162.434 87.7693 162.473 87.4845L163.691 78.3909C163.73 78.1061 160.221 77.8733 155.856 77.871Z"
        fill="#F7F7F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_3543_5528">
        <rect width="201" height="119" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgEmptyTable
